// These functions refer to the status-color of the object, as defined by Grommet in the theme.json
import React, {useState} from 'react'
import {Box,Text,Card,CardHeader,CardBody,CardFooter,Layer,DataTable,Spinner,Button,Tag ,Heading,Tip,List,NameValueList, NameValuePair, TextInput} from 'grommet'
import moment from 'moment';
import {Organization,Globe,User,Phone,MailOption,StatusGood,Deliver,FormUpload, Calendar, Package, Notes, CircleInformation, Clock, StatusCritical, FormClose, Copy, Location, MapLocation, Redo,Add, Mail} from 'grommet-icons';
import Flag from 'react-world-flags'
import { API,Auth } from 'aws-amplify';
import {LoadLayer} from './shared'

export function ReturnInvoiceStatus(status){
    switch(status){
      case 'Not Sent':
        return "status-disabled";
      case 'Paid':
        return "status-ok";
      case 'Pending Payment':
        return 'status-warning';
      case 'Overdue':
        return 'status-critical';
      case 'Not Applicable':
        return 'status-disabled';
      case 'Open':
        return 'status-ok'
      default:
        return 'status-disabled'
    }
  }

  export function ReturnShipmentStatus(status){
    switch(status){
      case 'Open':
        return "status-ok";
      case 'In Transit':
        return "status-ok";
      case 'Delivered':
        return 'brand';
      case 'Exception':
        return 'status-warning';
      case 'Fail':
        return 'status-error'
      case 'Cancelled':
        return 'status-unknown'
      default:
        return 'status-disabled'
    }
  }

  function ReturnAWBNumber(datum){
    if (datum.pieces.CollectionReference){

      return <Tip plain width='large' dropProps={{ align: { bottom: 'top' } }}content={<ReturnCollectionRef pieces={datum.pieces}/>}><Text size='small'>{datum.awb_number}</Text></Tip>
    } else {
      return <Text size='small'>{datum.awb_number}</Text>
    }
  }

  function ReturnLongString(str){
    if (str.length > 22){
      return `${str.substring(0,22)}...`
    } else {
      return str
    }
  }

  export function NotificationEmails(props){
    return (
      <Box direction='row'>
        {(props.notificationEmails.map(email => {
          return (
            <TextInput icon={<Mail />} />
          )
        }))}
        <Button margin='small' hoverIndicator icon={<Add color='brand'/>} onClick={() => {}} color='brand'/>
      </Box>
    )
   

  }

  function ReturnCollectionRef(props){
    var date = props.pieces.PickupDateTime.substring(0, props.pieces.PickupDateTime.length - 9);
    return <Box round background='background-front' pad='small'><Box direction='row' margin='small'><Notes color='brand' margin='small' pad='small' /><Text margin='xsmall' size='small'>Collection Reference: <strong>{props.pieces.CollectionReference}</strong></Text></Box><Box direction='row' margin='small'><Calendar color='brand' margin='small' pad='small' /><Text weight={'bold'} margin='xsmall' size='xsmall' >{moment(date).format("dddd DD MMMM YYYY")}</Text></Box><Box direction='row' margin='small'><Clock color='brand' margin='small' pad='small'/><Text weight={'bold'} size='xsmall' margin='xsmall' >{moment(date).format("HH:MM")} - {props.pieces.PickupCloseTime}</Text></Box></Box>
  }

  function CopyRowToClipboard(data){
    return `${data.user} \t ${data.details.name} \t ${data.origin.country.CountryName} \t ${data.destination.contact.companyName} \t ${data.destination.country.CountryName} \t ${data.awb_number} \t "" \t ${data.quote.total_quote_price} \t ${data.quote.quoted_weight} \t "" \t "" \t "" \t "" \t "" \t "" \t "" \t "" \t "" \t ${data.pieces.Packages[0].Commodity} \t ${data.pieces.CustomerPO} `
  }

  export function ShipmentTableColumns(datum,showQuote,copyRow,props,setClickableRow,reshipShipment){
    var columns = [{property: "id",header: <Text size='small' weight='bold'>ID</Text>,sortable: true,size: "75px",search: false},{ header: <Text size='small' weight='bold'>Date Booked</Text>, property: "created_at", sortable: true, search: false, render: (datum) => <Text size='small'>{moment(datum.created_at).format("DD-MM-YYYY")}</Text>, }, {  header: <Text size='small' weight='bold'>Status</Text>, property: "status", sortable: true, search: false, render: (datum) => <StatusChip shipment={datum} />, }, { property: "user", header: <Text size='small' weight='bold'>User</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small'>{ReturnLongString(datum.user)}</Text>}, { property: "lab.name", header: <Text size='small' weight='bold'>Account</Text>, sortable: true, search: false,render: (datum) => <Text size='small'>{ReturnLongString(datum.details.name)}</Text> }, { property: "origin.country.CountryName", header: <Text size='small' weight='bold'>Origin</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small'>{datum.origin.country.CountryName}</Text> }, { property: "destination.country.CountryName", header: <Text weight='bold' size='small'>Destination</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small'>{datum.destination.country.CountryName}</Text> }, { property: "quote.quoted_weight", header: <Text size='small' weight='bold'>Weight</Text>, pad: 'xsmall', sortable: true, size: "65px", search: false, render: (datum) => <div><Text size='small'>{datum.quote.quoted_weight}</Text> <Text size='xsmall' weight='bold'>{datum.quote.unit_of_measure}</Text></div> }, { property: "pieces.CustomerPO", header: <Text size='small' weight='bold'>Customer PO</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small'>{datum.pieces.CustomerPO}</Text> }, { property: "awb_number", header: <Text size='small' weight='bold'>AWB Number</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => ReturnAWBNumber(datum)},{header: <Text size='small' weight='bold'></Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <div onMouseLeave={() => {setClickableRow(true)}} onMouseEnter={() => {setClickableRow(false)}}><Button hoverIndicator style={{zIndex: 10}} primary onClick={() => {props.props.history.push({pathname: '/shipment/new', reship:true, origin: datum.origin, destination: datum.destination, details:datum.pieces})}}  size='small' label='Reship' icon={<Redo />}/></div>}]
    if (copyRow){
      columns.push({header: <Text size='small' weight='bold'>Copy Row Data</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Button onClick={() => {navigator.clipboard.writeText(CopyRowToClipboard(datum))}} size='small' plain={true} icon={<Copy />}/>})
    }
    if (showQuote){
      columns.splice(4,0,{property: "quote.total_quote_price",header: <Text size='small' weight='bold'>Quote</Text>,pad: 'xsmall',sortable: true,size: "75px",search: false,render: (datum) => <div><Text size='small'>${returnQuoteFloat(datum.quote.total_quote_price)} </Text><Text weight='bold' size='xsmall'>{datum.quote.total_quote_price_currency}</Text></div>})
    }
    return columns
  }

  export function BillingTableColumns(datum,showQuote,copyRow,props,setClickableRow,reshipShipment){
    var columns = [{property: "account_number",header: <Text size='small' weight='bold'>Courier Billing Account</Text>,sortable: true,search: false,render: (datum) => <div><Text size='small' weight={'bold'}>{datum.account_number}</Text><br /><Text size='xsmall'>{datum.courier_key} {datum.account_origin}</Text></div>},{ header: <Text size='small' weight='bold'>Shipment Date</Text>, property: "created_at", sortable: true, search: false, render: (datum) => <Text size='small'>{moment(datum.created_at).format("DD-MM-YYYY")}</Text>, },{ property: "awb_number", header: <Text size='small' weight='bold'>AWB Number</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small' weight='bold'>{datum.awb_number}</Text>}, {  header: <Text size='small' weight='bold'>Invoice Status</Text>, property: "status", sortable: true, search: false, render: (datum) => <Text size='small'>{datum.invoice_status}</Text>, },{ property: "lab.name", header: <Text size='small' weight='bold'>Account</Text>, sortable: true, search: false,render: (datum) => <Text size='small'>{datum.details.name}</Text> }, { property: "origin.country.CountryName", header: <Text size='small' weight='bold'>Origin</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small'>{datum.origin.country.CountryName}</Text> }, { property: "destination.country.CountryName", header: <Text weight='bold' size='small'>Destination</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small'>{datum.destination.country.CountryName}</Text> }, { property: "quote.quoted_weight", header: <Text size='small' weight='bold'>Quoted Weight (KG)</Text>, pad: 'xsmall', sortable: true, size: "65px", search: false, render: (datum) => <div><Text size='small'>{datum.quote.quoted_weight}</Text> </div> },{property: "quote.total_quote_price",header: <Text size='small' weight='bold'>Quote (USD)</Text>,pad: 'xsmall',sortable: true,size: "75px",search: false,render: (datum) => <div><Text size='small'>${returnQuoteFloat(datum.quote.total_quote_price)} </Text></div>},{ property: "shipment.total_billed_weight", header: <Text size='small' weight='bold'>Billed Weight (KG)</Text>, pad: 'xsmall', sortable: true, size: "65px", search: false, render: (datum) => <div><Text size='small'>{datum.total_billed_weight}</Text> </div> },{property: "shipment.total_billing_price",header: <Text size='small' weight='bold'>Total Bill (USD)</Text>,pad: 'xsmall',sortable: true,size: "75px",search: false,render: (datum) => <div><Text size='small'>${returnQuoteFloat(datum.total_billing_price)} </Text></div>}, { property: "pieces.CustomerPO", header: <Text size='small' weight='bold'>Customer PO</Text>, pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='small'>{datum.pieces.CustomerPO}</Text> }]
    return columns
  }

  function returnQuoteFloat(quote){
    if (parseFloat(quote)){
      return parseFloat(quote).toFixed(2)
    }
  }

  export function InvoiceChip(shipment){   
      return (
        <Box direction='row' margin='xsmall'><Tag background={{ color: ReturnInvoiceStatus(shipment.shipment.billing.InvoiceStatus), opacity: "strong" }} size='small' name={'Invoice'} value={shipment.shipment.billing.InvoiceStatus} /></Box>
      );
  };

  export function StatusChip(shipment){
    let statusText;
    let statusName;
    if (shipment.label === 'status' || shipment.label === undefined){
      statusText = <Text size='small'>{shipment.shipment.status}</Text>
      statusName = (shipment.label === undefined ? null : <Text size='small'>Status</Text>)
    } else {
      statusText = shipment.shipment.status
      statusName = 'Status'
    }
      return (
        <Box direction='row' margin='xsmall'><Tag background={{ color: ReturnShipmentStatus(shipment.shipment.status), opacity: "strong" }} size='xsmall' name={statusName} value={statusText} /></Box>
      );
  };

  export function ReturnBillableWeight(quote){
    if (quote.quoted_weight > quote.total_actual_weight){
        return (
          <Box direction='row' margin='xsmall'><Tag background='brand' size='small' name="Billable Weight" value={`${quote.quoted_weight} KG (Volumetric Weight)`} /></Box>
        )
    } else {
        return (
          <Box direction='row'><Tag background='brand' size='small' name="Billable Weight" value={`${quote.quoted_weight} KG`} /></Box>
        )
    }
}

export function ReturnLocation(props){
  const location = props.location
  const label = props.locationType
  return (
      <Card elevation='large' style={{minWidth:400, overflowX: 'scroll'}} pad='medium' background='background-front' round margin={'small'}>
            <CardHeader margin='xsmall'><Box direction='row'><Location color='brand'/><Text size="medium" weight={'bold'}  margin={{left: 'small'}}>{label}</Text></Box></CardHeader>
          <CardBody margin='small'>
          <NameValueList margin='small'>
            <NameValuePair name={<Box direction='row'><Organization color='brand' /><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Company Name</Text></Box>} icon={<Organization />}>
              <Text size='small'>{location.contact.companyName}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><MapLocation color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Address</Text></Box>}>
            {(location.hasOwnProperty("address_line_two") && location.address_line_two !== ''  ? <Text size='small'>{location.address_line_one} ,</Text> : <Text size='small'>{location.address_line_one}</Text>)}
            {(location.hasOwnProperty("address_line_two") && location.address_line_two !== '' ? <Text size='small'>{location.address_line_two}</Text> : '')}{(location.hasOwnProperty('address_line_three') && location.address_line_three !== '' ? <Text size='small'>, {location.address_line_three}</Text>: null)}
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Location color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>City</Text></Box>}>
            <Text size='small'>{location.city}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Location color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Postal Code</Text></Box>}>
            <Text size='small'>{location.postcode}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Location color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Country</Text></Box>}>
            <Box direction='row'><Text size='small' >{location.country.CountryName}</Text><Flag style={{marginTop: 1, marginLeft: 15}}height='20' code={location.country.CountryCode} fallback={ <Text size='xsmall'>Unknown</Text> }/></Box>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><User color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Contact Name</Text></Box>}>
            <Text size='small'>{location.contact.contactName}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><MailOption color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Contact Email</Text></Box>}>
            <Text size='small'>{location.contact.contactEmail}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Phone color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Contact Phone</Text></Box>}>
            <Text size='small'>{location.contact.contactPhone}</Text>
            </NameValuePair>
          </NameValueList>
          </CardBody>
      </Card>
  )
}

export function ReturnQuoteLocation(props){
  const location = props.location
  const label = props.locationType
  return (
      <Card pad='medium' background={'background-front'} round gap="small">
          <CardHeader> <Globe color='brand'/><Text size="medium">{label}</Text> <Flag style={{margin: 4}}height='30' code={location.country.CountryCode} fallback={ <Text size='xsmall'>Unknown</Text> }/> </CardHeader>
          <CardBody gap='xsmall' margin='small'> <Box direction='row' justify='between'><Text size='small'>{location.country.CountryName}</Text></Box> <Text size="small">{location.city}, {location.postcode}</Text> </CardBody>
      </Card>
  )
}

export function ReturnBaseUrl(user){
  if (user === 'SuperAdmin'){
    return 'shipments'
  } else if (user === 'Lab'){
    return 'lab_shipments'
  } else {
    return 'customer_shipments'
  }
}

export function WhichUrl (params,user){
  let baseUrl = ReturnBaseUrl(user)
  if (Array.isArray(params)){
    return `/${baseUrl}?date_from=${params[0]}&date_to=${params[1]}`
  } else if (params === null){
    return `/${baseUrl}`
  } else if (isNaN(parseInt(params))){
      return `/${baseUrl}?status=${params.trim()}`
  } else if (params.hasOwnProperty('awbNumber')){
    var trim_string = params.awbNumber.trim()
    return `/${baseUrl}?awb_number=${trim_string}`
   } else {
    trim_string = params.trim()
    return `/${baseUrl}?awb_number=${trim_string}`
  }
}

export function ReturnCollcectionReference(props){
  let collRef;
  if(props.shipment.pieces.CollectionReference != null){
    if (props.shipment.pieces.CollectionReference.includes("A collection")){
      collRef = <NameValuePair name={<Box direction='row'><CircleInformation color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Collection Reference</Text></Box>}><Text size='small'>{props.shipment.pieces.CollectionReference}</Text></NameValuePair>
    } else 
    {
      collRef = <NameValuePair name={<Box direction='row'><CircleInformation color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Collection Reference</Text></Box>}><Text size='small'>{props.shipment.pieces.CollectionReference}</Text></NameValuePair>
    }
  } else {
      collRef = null
  }
  return collRef
}



export function ReturnCollectionDetails(props){
  const [showTrackingOverlay, setShowTrackingOverlay] = useState(false)
  const [load, setLoad] = useState(false)
  const [err, setErr] = useState(false)
  const onClose = () => setErr(false);
  const fetchShipmentTracking = (shipment) => {
    setLoad(true)
    Auth.currentSession().then(session => {
      API.post("LabShip", '/get_shipment_tracking_status',{headers: {Authorization: session.idToken.jwtToken,},body:{shipment: shipment}})
        .then(
          (result) => {
            if (result.status === 'success'){
              setLoad(false)
              setShowTrackingOverlay(true)
              props.setShipment(result.shipment)
            } else {
              setShowTrackingOverlay(true)
              setErr(true)
              setLoad(false)
              setTimeout(() => {
                setErr(false);
              }, 5000);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    })
  }
  const shipment = props.shipment
  const user = (props.props === undefined ? props.user : props.props.user) 
  const fail = (props.shipment.status === 'Fail' && props.shipment.messages.length > 0 ? true : false)
  if (fail){
    return (
      <Card elevation='large' margin={'small'} pad="medium" background={'background-front'} round gap="small" overflow={'scroll'} overflowx='scroll'>
        {err && (
        <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }} onEsc={onClose} responsive={false} plain>
        <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-critical">
            <Box align="center" direction="row" gap="xsmall">
            <StatusCritical color='light-1'/>
            <Text color='light-1' background='light-1'>
              Tracking failed, please try again later. 
            </Text>
            </Box>
            <Button icon={<FormClose color='light-1'/>} onClick={onClose} plain />
            </Box>
        </Layer>
        )}
        <LoadLayer load={load} label={'Loading Tracking...'} />
          <CardHeader><Box direction='row'><Deliver color='brand' /><Text size="medium" weight={'bold'}  margin={{left: 'small'}}>Shipment Details</Text></Box></CardHeader>
          <CardBody>
              <Box direction='row' justify='start' margin='small'><Tag margin={{left: 'xsmall'}} background='status-critical' size='small' name="Error Message" value={props.shipment.messages[0].response_message_title} /><Tag margin={{left: 'xsmall'}} background='status-critical' size='small' name="Code" value={props.shipment.messages[0].response_message_code} /><Tag margin={{left: 'xsmall'}} background='brand' size='small' name="Collection Date" value={moment(shipment.pieces.PickupDateTime.split("GMT")[0]).format("DD/MM/YYYY")} /><Tag margin={{left: 'xsmall'}} background='brand' size='small' name="Time" value={`${moment(shipment.pieces.PickupDateTime.split("GMT")[0]).format("HH:mm")} - ${shipment.pieces.PickupCloseTime}`} /></Box>
               <ReturnCollcectionReference shipment={shipment} props={props}/>
               <Text margin='small'>{props.shipment.messages[0].response_message} - {props.shipment.messages[0].response_message_detail}</Text>
               {((props.shipment.messages[0].hasOwnProperty('response_message_additional_detail')) ?
                  <List data={ props.shipment.messages[0].response_message_additional_detail} />
                :
                null
                )}
          </CardBody>
      <ReturnShipmentTracking shipment={props.shipment} load={load} setShowTrackingOverlay={setShowTrackingOverlay} showTrackingOverlay={showTrackingOverlay}  />
      </Card>

  )
  } else {
    return (
      <Card elevation='large' margin={'small'} pad="medium" background={'background-front'} round overflow='scroll'>
        {err && (
        <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }} onEsc={onClose} responsive={false} plain>
        <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-critical">
            <Box align="center" direction="row" gap="xsmall">
            <StatusCritical color='light-1'/>
            <Text color='light-1' background='light-1'>
              Tracking failed, please try again later. 
            </Text>
            </Box>
            <Button icon={<FormClose color='light-1'/>} onClick={onClose} plain />
            </Box>
        </Layer>
        )}
        <LoadLayer load={load} label={'Loading Tracking...'} />
          <CardHeader margin='xsmall'><Box direction='row'><Deliver color='brand' /><Text size="medium" weight={'bolder'}  margin={{left: 'small'}}>Shipment Details</Text></Box><StatusChip shipment={shipment} label={'status'} /></CardHeader>
          <CardBody style={{maxWidth:800}} margin='small'>
          <Box></Box>
          <NameValueList margin='small'>
            <NameValuePair name={<Box direction='row'><Notes color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Shipment AWB Number</Text></Box>}>
              <Text size='small' >{props.shipment.awb_number}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Calendar color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Collection Date</Text></Box>}>
              <Text size='small'>{moment(shipment.pieces.PickupDateTime.split("GMT")[0]).format("DD/MM/YYYY")}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Clock color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Collection Time Slot</Text></Box>}>
            <Text size='small'>{`${moment(shipment.pieces.PickupDateTime.split("GMT")[0]).format("HH:mm")} - ${shipment.pieces.PickupCloseTime}`}</Text>
            </NameValuePair>
            <ReturnCollcectionReference shipment={shipment} props={props}/>
            <ReturnLatestTrackingMessage shipment={shipment} />
           
            {(user === 'SuperAdmin' ? <NameValuePair name={<Box direction='row'><Notes color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Account Number</Text></Box>}> <Text size='small' >{shipment.account_number}</Text> </NameValuePair> : null )}
            {(user === 'SuperAdmin' ? <NameValuePair name={<Box direction='row'><Notes color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Account Details</Text></Box>}> <Text size='small' >{shipment.courier_key}, {shipment.account_origin}</Text> </NameValuePair> : null )}
          </NameValueList>
          </CardBody>
          <CardFooter>
          {(shipment.status === 'Delivered' ? <Button disabled margin={{right: 'small', top:'small'}} icon={<MapLocation />} size='small' primary label='Track Shipment' hoverIndicator onClick={() => fetchShipmentTracking(props.shipment)}/>:          <Button margin={{right: 'small', top:'small'}} icon={<MapLocation />} size='small' primary label='Track Shipment' hoverIndicator onClick={() => fetchShipmentTracking(props.shipment)}/> )}
          </CardFooter>
          <ReturnShipmentTracking shipment={props.shipment} load={load} setShowTrackingOverlay={setShowTrackingOverlay} showTrackingOverlay={showTrackingOverlay}  />
      </Card>
  )
  }
}

export function ReturnTotalWeight(shipment){
  let weight = 0;
  shipment.pieces.Packages.forEach(pack => {
      var a = parseFloat(pack.Weight)
      weight += a
  })
  return weight
}

export function ShipmentSuccessNotification(props){
  let dg;
  if (props.label.includes("Dangerous Goods")){
    dg = (
      <Text color='light-1' background='light-1'>We will process your request and be in contact with you shortly.</Text>
    )
  }
  if (props.method){
    return (
      <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }} responsive={false} plain>
          <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-ok">
           <Box align="center" direction="row" gap="xsmall"><StatusGood color='light-1'/><Text color='light-1' background='light-1'>{props.label} successfully {props.method}!</Text></Box>
          </Box>
      </Layer>
    )
  } else {
    return (
      <div>
      <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }} responsive={false} plain>
          <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-ok">
            {(props.edit ? <Box align="center" direction="row" gap="xsmall"><StatusGood color='light-1'/><Text color='light-1' background='light-1'>{props.label} successfully updated!</Text></Box> : <Box align="center" direction="row" gap="xsmall"><StatusGood color='light-1'/><Text color='light-1' background='light-1'>{props.label} successfully created! {dg}</Text></Box> )} 
          </Box>
      </Layer>
      {dg}
      </div>
    )
  }

}

export function SearchBarNotifications(props){
  let view;
  if (props.error){
    view = (
      <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }} responsive={false} plain>
        <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-critical">
          <Box align="center" direction="row" gap="xsmall"><StatusCritical color='light-1'/><Text color='light-1' background='light-1'>No Shipments Found</Text></Box> 
        </Box>
    </Layer>
    )
  } else {
    view = (
      <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }} responsive={false} plain>
        <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-ok">
          <Box align="center" direction="row" gap="xsmall"><StatusGood color='light-1'/><Text color='light-1' background='light-1'>Shipment {props.awbNumber} successfully found!</Text></Box> 
        </Box>
    </Layer>
    )
  }
  return view
}

export function MultpleShipmentsResultsLayer(props){
  let view;
    view = (
      <Layer margin={{ vertical: 'medium', horizontal: 'small' }} onEsc={() => {props.setMultipleShipmentResults(false)}} overflow='scroll'>
      <Box margin={'small'} justify='center' direction='row'><CircleInformation style={{marginTop: 22}} color='status-ok' /><Heading margin={{left: 'small'}} level={4}>{props.shipments.length} Shipments Found</Heading></Box>
        <Box margin='small' >
          <Text margin={'small'} weight='bold'>Please Select from Shipments below</Text>
        <DataTable onClickRow={({datum}) => {props.history.push({pathname:`/shipment/${datum.id}`, shipment: datum}); props.setMultipleShipmentResults(false)}}data={props.shipments} columns={[{ header: "ID", property: "id", pad: 'xsmall', sortable: true, search: false},{ header: "Date Booked", property: "created_at", pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text>{moment(datum.created_at).format("DD-MM-YYYY")}</Text> },{ header: "AWB Number", property: "awb_number", pad: 'xsmall', sortable: true, search: false},{ header: "Origin", property: "origin.country.CountryName", pad: 'xsmall', sortable: true, search: false},{ header: "Destination", property: "destination.country.CountryName", pad: 'xsmall', sortable: true, search: false}]} />
        </Box>
      </Layer>
    )
  return view
}

export function ReturnTrackingEvents(shipment, load){
  let trackingEvents; 
        if (load){
          trackingEvents = (<Box alignSelf='center' align='center' justify='center' direction='column' margin="medium" width='small' height='xsmall'><Spinner /><Text size='xsmall' pad='medium' margin='medium'>Loading Tracking...</Text></Box>)
        } else {
          if(shipment.tracking === null){
            trackingEvents = null 
          } else {
            trackingEvents = (
              <Box overflow='scroll' ><DataTable overflow='scroll' border={{"body":"bottom"}} margin='xsmall' background={{header: { color: '#18445C'},footer: { color: 'dark-3', opacity: 'strong' }}} onClickRow={()=>{}} data={shipment.tracking.Tracking.TrackingEvents.reverse()} columns={[{sortable:true, property: 'Date',header: <Text>Date</Text>,primary: true,pad:'xsmall',render: (datum) => <Text >{moment(datum.Date).format("DD-MM-YYYY")}</Text>},{property: 'Time',header: <Text>Time</Text>,pad:'xsmall',render: (datum) => <Text >{datum.Time}</Text>},{property: 'Description',header: <Text>Event</Text>,pad:'xsmall',render: (datum) => <Text >{datum.Description}</Text>},{property: 'ServiceArea',header: <Text>Location</Text>,pad:'xsmall',render: (datum) => <Text >{datum.ServiceArea}</Text>}]}/></Box>
            )
          }
        }
        return trackingEvents
}

export function ReturnShipmentTracking(props){
  const shipment = props.shipment
  if (shipment.tracking){
    return (
      <Box>        
         {props.showTrackingOverlay && (
          <Layer><Box margin="small" width='xlarge'>
            <Box direction='row' margin='xsmall' justify='between'><Button icon={<FormClose color='brand' />} hoverIndicator onClick={() => {props.setShowTrackingOverlay(false)}}/><Box><Text weight={'bold'} alignSelf='center' margin={{top:'small'}}>Tracking Events</Text></Box><Box><Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="AWB Number" value={`${shipment.awb_number}`} /></Box></Box></Box>
             {ReturnTrackingEvents(shipment,props.load)}                
          </Box>
        </Layer>
        )}
      </Box>
    )
  } else {
    return null;
  }
}

export function ReturnLatestTrackingStatus(props){
  const shipment = props.shipment
  if (shipment.tracking){
    return (
      <Box direction='row'>
                <Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="Billable Weight" value={`${props.shipment.quote.quoted_weight} KG`} /></Box>
        <Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="Current Tracking" value={`${shipment.tracking.Tracking.LatestTrackingEvent.Description} at ${shipment.tracking.Tracking.LatestTrackingEvent.Time} on ${moment(shipment.tracking.Tracking.LatestTrackingEvent.Date).format("DD-MM-YYYY")}`} /></Box>
      </Box>
    )
  } else if (shipment.quote.transit_details){
    return (
      <Box direction='row'>
        <Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="Billable Weight" value={`${props.shipment.quote.quoted_weight} KG`} /></Box>
     </Box>
    )
  } else {
    return(
      <Box direction='row'>
        <Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="Billable Weight" value={`${props.shipment.quote.quoted_weight} KG`} /></Box>
      </Box>
    )
  }
}

export function ReturnLatestTrackingMessage(props){
  const shipment = props.shipment
  if (shipment.tracking){
    return (
      <NameValuePair name={<Box direction='row'><MapLocation color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight='bold'>Latest Tracking</Text></Box>}>
        <Text size='small'>{shipment.tracking.Tracking.LatestTrackingEvent.Description} at {shipment.tracking.Tracking.LatestTrackingEvent.Time} on {moment(shipment.tracking.Tracking.LatestTrackingEvent.Date).format("DD-MM-YYYY")}</Text>
      </NameValuePair>
    )
  } else {
    return null;
  }
}

export function RequestButton(props){
  if (props.load){
    return <Spinner />
  } else {
    return <Button primary label={props.label} type='submit' icon={<FormUpload />}/>
  }
} 


export function ReturnCommodity(pieces){
  console.log(pieces)
  var totalCustomsValue = 0
  pieces.Packages.forEach(piece => {
     totalCustomsValue += parseFloat(piece.customsValue)
  })
  return (
      <Card style={{minWidth: 300}} pad="medium" background={'background-front'} round gap="small" elevation='medium'>
          <CardHeader justify='start' margin={'small'}>
              <Package color='brand'/><Text weight={'bold'} size="medium">Package Details</Text>
          </CardHeader>
          <CardBody margin={'xsmall'} overflow='scroll'>
             <Text margin={'xsmall'} size='small'>Total Shipment Pieces: {pieces.Packages.length}</Text>
             <Text margin={'xsmall'} size='small'>Total Declared Customs Value: {totalCustomsValue} USD</Text>
          </CardBody>
      </Card>
  )
}
